<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="w-100 h-100">
        <template-listing-item-base v-bind:id="template.Id"
                                    v-bind:name="template.Name"
                                    v-bind:date="template.Modified"
                                    v-bind:can-delete="canDelete"
                                    v-bind:can-edit="canEdit"
                                    @template-deleted="$emit('template-deleted', $event)"
                                    @template-selected="$emit('template-selected', $event)"
        >
            <template v-slot:sub-text-label="{ formattedDate }">
                {{ resource('TemplatePrimaryListing_Item_SubTextLabel') }} {{ formattedDate }}
            </template>

            <template v-slot:additional-controls>
                <i
                        v-if="canShare"
                        class="fas fa-share-alt mdb-icon-btn-warning fa-lg mr-1"
                        aria-hidden="true"
                        @click.stop="displayShareDialog = !displayShareDialog"
                ></i>
            </template>
        </template-listing-item-base>

        <template-share v-if="displayShareDialog" v-bind:template-id="template.Id"></template-share>
    </div>
</template>

<script>
    import templateManagerApi from '../../../../Api/template-manager';
    
    import securityApi from '../../../../Util/security';
    
    import resourceMixin from '../../../../Util/Mixins/resources';
    
    import TemplateListingItemBase from './TemplateListingItemBase.vue';
    import TemplateShare from './../TemplateShare.vue';

    export default {
        name: "template-primary-listing-item",
        components: {
            TemplateListingItemBase,
            TemplateShare
        },
        mixins: [resourceMixin],
        beforeCreate(){
            const vm = this;
            
            templateManagerApi.validateBuilderPermission(securityApi.PermissionGrantTypes.Write).then(
                canWrite => {
                    vm.canShare = canWrite;
                    vm.canEdit = canWrite;
                }
            );
            
            templateManagerApi.validateBuilderPermission(securityApi.PermissionGrantTypes.Delete).then(
                canDelete => vm.canDelete = canDelete
            );
        },
        data(){
            return {
                canShare: false,
                canDelete: false,
                canEdit: false,
                displayShareDialog: false
            }
        },
        props: {
            template: {
                type: Object,
                required: true,
                default() {
                    return {
                        Id: '',
                        Name: '',
                        Modified: new Date()
                    }
                }
            }
        }
    };
</script>
